<template>
    <section class="article" v-if="this.$store.state.settings.site_id === 1">
        <DeliveryRu/>
    </section>
    <section class="article" v-else-if="this.$store.state.settings.site_id === 2">
        <DeliveryEn/>
    </section>
</template>

<script>
import DeliveryRu from './ru/delivery.vue'
import DeliveryEn from './en/delivery.vue'
export default {
    components:{
        DeliveryRu,DeliveryEn
    },
    name: "delivery"
}
</script>

<style scoped>

</style>
